import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
// import logo from '../../../assets/images/smLogo.svg';
// import lgLogo from '../../../assets/nav/expandLogo.svg';
// import logo from '../../../assets/nav/smLogo-old.svg';
// import lgLogo from '../../../assets/nav/logo-old.svg';
// import logo from '../../../assets/nav/new-logo-sm.svg';
// import lgLogo from '../../../assets/nav/new-logo-lg.svg';
import logo from '../../../assets/nav/new-logo-sm-2.svg';
import lgLogo from '../../../assets/nav/new-logo-lg-2.svg';
import iconArrow from '../../../assets/icon-arrow-down.svg';
import { NavData } from '../../Constant';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import help from '../../../assets/nav/help-icon.svg';
import logout from '../../../assets/nav/logout-icon.svg';
import { RiArrowLeftSLine, RiArrowRightSLine } from 'react-icons/ri';
import { StyledSideBar } from './SideBar.styles';
import ModalContainer from '../../molecules/ModalContainer';
import PricingSection from '../Pricing/PricingSection';
import { GoArrowUp } from 'react-icons/go';
import ProfilePic from '../../../assets/uploadIcon.svg';
import SidebarCredits from './SidebarCredits';
import useFixedTooltip from '../../../hooks/useFixedTooltip';
import FixedTooltipPortal from '../../molecules/FixedTooltipPortal';
import { AiOutlineDollar } from "react-icons/ai";
import { SidebarTooltip } from './SideBar.styles';

const SideBar = () => {
  const [sideBar, setSideBar] = useState(true);
  const [creditActive, setCreditActive] = useState(false);
  const {
    containerRef: scrollRef,
    showTooltip,
    hideTooltip,
    activeContent: activeLabel,
    tooltipVisible,
    tooltipPos,
  } = useFixedTooltip([sideBar], { offsetX: 12, anchorMode: 'trigger' });
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const creditsRef = useRef(null);
  const { onLogout, user, allowedPages } = useContextHook(AuthContext, v => ({
    onLogout: v.onLogout,
    user: v.user,
    allowedPages: v.allowedPages,
  }));

  const stripeSubscriptionId = user?.data?.subscriptionDetail?.stripeSubscriptionId;
  const hasManualSubscription =
    typeof stripeSubscriptionId === 'string' && stripeSubscriptionId.startsWith('manual_subscription');
  const [selectedOrg, setSelectedOrg] = useState('Organization');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleDropdownToggle = e => {
    e.stopPropagation();
    setDropdownOpen(prev => !prev);
  };

  const handleSelect = (org, e) => {
    e.stopPropagation();
    setSelectedOrg(org);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = e => {
      if (!e.target.closest('.select-box')) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, []);



  const getFilteredNavData = () => {
    if (allowedPages && allowedPages.length > 0) {
      const filteredData = NavData.filter(item => {
        if (hasManualSubscription && item?.path === 'teams') {
          return false;
        }
        const route = `/${item.path}`;
        return allowedPages.includes(route);
      });

      return filteredData;
    }

    if (hasManualSubscription) {
      return NavData.filter(item => item?.path !== 'teams');
    }

    return NavData;
  };

  const handleSideBar = () => {
    creditsRef.current?.close();
    setSideBar(!sideBar);
  };
  useLayoutEffect(() => {
    if (sideBar) {
      document.body.classList.add('aside-active');
    } else {
      document.body.classList.remove('aside-active');
    }
  }, [sideBar]);

  const filteredNavData = getFilteredNavData();
  const dashboardItem = filteredNavData.find(item => item?.path === 'dashboard');
  const quickActionsOrder = ['campaign-manager', 'unibox'];
  const orderedNavData = [
    ...(dashboardItem ? [dashboardItem] : []),
    ...quickActionsOrder
      .map(path => filteredNavData.find(item => item?.path === path))
      .filter(Boolean),
    ...filteredNavData.filter(item => item?.path !== 'dashboard' && !quickActionsOrder.includes(item?.path)),
  ];
  const sectionHeadingByPath = {
    'unibox': 'Quick Actions',
    'campaign-manager': 'Quick Actions',
    'leads-module': 'Manage Leads',
    'import-jobs': 'Manage Leads',
    'leads-list': 'Manage Leads',
    'pending-approvals': 'AI Messages',
    'email-accounts': 'Accounts',
    'linkedin-accounts': 'Accounts',
    'teams': 'Accounts',
    'profile': 'Preferences',
  };
  const renderedSectionHeadings = new Set();

  const matchesNavPath = elem => {
    const { pathname } = location;
    if (elem.path === 'dashboard') {
      return ['/dashboard', '/get-started'].includes(pathname);
    }
    if (elem.path === 'leads-module') {
      return pathname === '/leads-module' || pathname.startsWith('/lead-preview');
    }
    if (elem.path === 'leads-list') {
      return pathname === '/leads-list' || pathname.startsWith('/single-list-lead');
    }
    return pathname === `/${elem.path}`;
  };

  const getNavLinkClassName = elem => () => (matchesNavPath(elem) ? 'active' : undefined);

  const showTooltipFromEvent = e => {
    if (sideBar) return;
    const focusable = e.target.closest('a, button');
    const anchor = focusable?.querySelector('[data-sidebar-tooltip]')
      ?? e.target.closest('[data-sidebar-tooltip]');
    if (!anchor) return;
    const label = anchor.getAttribute('data-sidebar-tooltip');
    if (label) showTooltip(anchor, label);
  };

  const hideTooltipFromEvent = e => {
    if (sideBar) return;
    const relatedTarget = e.relatedTarget;
    if (!(relatedTarget instanceof Node) || !e.currentTarget.contains(relatedTarget)) {
      hideTooltip();
    }
  };

  return (
    <>

      <StyledSideBar $sideBar={sideBar} $creditsOpen={creditActive} ref={navRef}>
        <div className="sidebar-header">
          <div className="logoWrapper">
            <Link to="/" className="logo-link">
              <img src={lgLogo} alt="logo" className="logo-lg" />
              <img src={logo} alt="logo" className="logo-sm" />
            </Link>
          </div>

          <button
            type="button"
            className="collapse-btn"
            onClick={handleSideBar}
            aria-label={sideBar ? 'Collapse sidebar' : 'Expand sidebar'}
          >
            <span className="arrow-wrap">
              <RiArrowLeftSLine className="arrow-icon arrow-left" aria-hidden />
              <RiArrowRightSLine className="arrow-icon arrow-right" aria-hidden />
            </span>
            <span className="collapse-label">Collapse</span>
            <span className="tooltip">Expand</span>
          </button>
        </div>

        {/* <div className="time-web-box">
          <div className="timeweb">
            <div className="img-box" onClick={handleSideBar}>
              <img src={iconWeb} width="23" alt="img" />
            </div>
            <strong className="title">Timeweb</strong>
            <div className={`select-box ${dropdownOpen ? 'open' : ''}`} onClick={handleDropdownToggle}>
              <span className="item">{selectedOrg}</span>
              <img className="icon" src={iconArrow} width="13" alt="arrow" />

              {dropdownOpen && (
                <ul className="select-drop">
                  {['Organization 1', 'Organization 2', 'Organization 3'].map((org, i) => (
                    <li key={i} onClick={e => handleSelect(org, e)}>
                      {org}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div> */}

        <div className="nav-wrapper">
          <div
            className="nav-scroll"
            ref={scrollRef}
            onMouseOver={showTooltipFromEvent}
            onMouseLeave={hideTooltipFromEvent}
            onFocus={showTooltipFromEvent}
            onBlur={hideTooltipFromEvent}
          >
            <div className="navigation">
              <ul className="nav-links">
                {orderedNavData?.map((elem, ind) => {
                  const sectionHeading = sectionHeadingByPath[elem?.path];
                  const shouldRenderHeading = sectionHeading && !renderedSectionHeadings.has(sectionHeading);
                  if (shouldRenderHeading) {
                    renderedSectionHeadings.add(sectionHeading);
                  }
                  if (elem?.path) {
                    return (
                      <React.Fragment key={ind}>
                        {shouldRenderHeading && (
                          <span className={`subheading${sideBar ? '' : ' is-collapsed'}`}>
                            {sideBar ? sectionHeading : '\u00A0'}
                          </span>
                        )}
                        <li className={matchesNavPath(elem) ? 'active' : undefined}>
                          <NavLink to={`/${elem.path}`} className={getNavLinkClassName(elem)} id={elem.path}>
                            <img src={elem?.img} alt={elem.path} className="icon" />
                            <span className="label">{elem?.name}</span>
                            <span
                              className="sidebar-tooltip-anchor"
                              data-sidebar-tooltip={elem?.name}
                              aria-hidden
                            />
                          </NavLink>
                        </li>
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <li key={ind}>
                        <NavLink to={`/${elem.path}`}>
                          <img src={elem.img} alt="No Link" className="icon" />
                          {sideBar && <span className="label">{elem?.name}</span>}
                          {sideBar && <span className="label-2">Comming soon</span>}
                        </NavLink>
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
            <span className={`subheading${sideBar ? '' : ' is-collapsed'}`}>
              {sideBar ? 'Preferences' : '\u00A0'}
            </span>
            <ul className="nav-links system">
              <li>
                <SidebarCredits
                  ref={creditsRef}
                  sideBar={sideBar}
                  navRef={navRef}
                  onOpenChange={setCreditActive}
                />
              </li>            {allowedPages?.includes('/subscription') && !hasManualSubscription && (
                <li>
                  <ModalContainer
                    newStyle
                    width={1200}
                    btnComponent={({ onClick }) => (
                      <button onClick={onClick} id="subscriptions-btn">
                        <AiOutlineDollar className="icon" color="#4C6484" />

                        <span className="label sub">Subscriptions</span>
                        <span
                          className="sidebar-tooltip-anchor"
                          data-sidebar-tooltip="Subscriptions"
                          aria-hidden
                        />
                        {!user?.data?.subscriptionDetail ? (
                          <span className="free-tag">Free</span>
                        ) : user?.data?.subscriptionDetail?.status === 'active' && (
                          <span className="free-tag">{user?.data?.subscriptionDetail?.currentPlan.replace('Plan', "").trim()}</span>
                        )}
                      </button>
                    )}
                    content={({ onClose }) => <PricingSection onClose={onClose} />}
                  />
                </li>
              )}
              <li className="profile">
                <button className="profile-text" onClick={() => navigate('/profile')}>
                  <div className="pic">
                    <img src={user?.data?.profilePicture ? user?.data?.profilePicture : ProfilePic} alt="profilePic" />
                    <GoArrowUp className="arrow-icon" color='var(--white)' size={15} />
                  </div>
                  <span className="label">Profile Settings</span>
                  <span
                    className="sidebar-tooltip-anchor"
                    data-sidebar-tooltip="Profile"
                    aria-hidden
                  />
                  {/* <div className="body">
                  <span className="name">{user?.data?.fullName}</span>
                  <span className="email">{user?.data?.email}</span>
                </div> */}
                </button>
              </li>
              <li>
                <button onClick={onLogout} className="logout">
                  <img src={logout} alt="logout" className="icon" />
                  <span className="label">Log out</span>
                  <span
                    className="sidebar-tooltip-anchor"
                    data-sidebar-tooltip="Log out"
                    aria-hidden
                  />
                </button>
              </li>
            </ul>
          </div>

          {allowedPages?.includes('/help-center') && (
            <NavLink className="help-center" target="_blank" to="https://intercom.help/houdiny-ai/en">
              <div className="img-box" >
                <img src={help} alt="help-icon" className="icon" id="help-center-btn" />
              </div>
              <span className="label">Help Center</span>
            </NavLink>
          )}
        </div>
      </StyledSideBar>
      <FixedTooltipPortal
        content={activeLabel}
        visible={tooltipVisible}
        position={tooltipPos}
        tooltipComponent={SidebarTooltip}
      />
    </>
  );
};

export default SideBar;
